import React from "react";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import ModalTopSection from "./ModalTopSection";
import ModalChannelsSection from "./ModalChannelsSection";
import ModalMyfreeSection from "./ModalMyFreeSection";
import DtvTheme from "@directv-digital/dds.ui.dtv-theme";
import MyhomeRsnTable from "./MyHomeRsnTable";
import { CardModalContentProps } from "../../package-carousel.props";

const styles = {
  modalContainerStyles: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "12px",
    alignContent: "flex-start",
    [DtvTheme.breakpoints.down(414)]: {
      gap: "16px 5px"
    },
    alignSelf: "stretch",
    flexWrap: "wrap",
    flexGrow: 1
  }
};

const CardModalContent = (props: CardModalContentProps) => {
  const {
    title,
    subHeading,
    offerRibbon,
    strikeThroughPrice,
    priceText,
    channelsLabel,
    localChannelsText,
    channels,
    rsnTeamsTableData,
    myFreeConfig,
    config
  } = props;

  try {
    return (
      <DtvBox
        id={"card-modal-container"}
        sx={{
          ...styles.modalContainerStyles
        }}
      >
        {/* Modal Top Section */}
        <ModalTopSection
          offerRibbon={offerRibbon}
          priceText={priceText}
          strikeThroughPrice={strikeThroughPrice}
          subHeading={subHeading}
          title={title}
        />
        {/* MyHome RSN Table - Note - Enhance to have a config driven Flags for MyHomeTeam */}
        {config?.id === "ATT_TV_MYHOMETEAM" && <MyhomeRsnTable {...rsnTeamsTableData} />}
        {/* Modal Channels Section */}
        <ModalChannelsSection
          channels={channels}
          channelsLabel={channelsLabel}
          localChannelsText={localChannelsText}
        />
        {/* Modal MyFree Section */}
        <ModalMyfreeSection {...myFreeConfig} />
      </DtvBox>
    );
  } catch (error) {
    return <ErrorDisplay component="CardModalContent" error={error} />;
  }
};

export default React.memo(CardModalContent);
